import { Injectable } from '@angular/core';

import { DataService } from '../data.service';
import { SimpleRepository } from './_simple.repository';
import { IGetallDTO } from 'src/app/model/dto/getall.dto';
import { Country } from 'src/app/model/orm/country.model';

@Injectable()
export class CountriesRepository extends SimpleRepository<Country> {
    constructor(protected dataService: DataService) {
        super();        
    }
    
    public load(): Promise<void> {
        return new Promise((resolve, reject) => {
            if (new Date().getTime() - this.loadedAt < this.ttl) {
                resolve();
            } else {
                const dto: IGetallDTO = {sortBy: this.sortBy, sortDir: this.sortDir};
                this.dataService.countriesAll(dto).subscribe(res => {                                                                                      
                    if (res.statusCode === 200) {
                        this.build(res.data);                           
                        this.loadedAt = new Date().getTime();
                        resolve();
                    } else {                        
                        reject(res.statusCode+": "+res.error);
                    }
                }, err => {
                    reject(err.message);
                });
            }            
        });
    }   
    
    public build(countries: Array<Country> = []): void {
        this.xl = countries.length ? countries.map(d => new Country().build(d)) : [];
    }
}
